// extracted by mini-css-extract-plugin
module.exports = {"xError":"style_xError__vxCqr"};